import { Chip, Tooltip } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
`;

export const Content = styled.div`
  padding: 15px;
  width: 100%;
`;

export const Row = styled.div`
  flex-direction: row;
  margin-bottom: 15px;
`;

export const ContainerSuperRecolhe = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
  background-color: #ffffff;
  border-radius: 4px;
  padding: 24px;
`;

export const SuperRecolheEditContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-self: flex-end;
`;

export const SuperRecolheChipEnable = styled(Chip)({
  "&.MuiChip-root": {
    backgroundColor: "transparent",
    color: "#4caf50",
    border: "1px solid #4caf50",
    borderRadius: "16px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    height: "24px",
  },

  "& .MuiChip-label": {
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
  },
});

export const SuperRecolheChipDisable = styled(Chip)({
  "&.MuiChip-root": {
    backgroundColor: "transparent",
    color: "#00000080",
    border: "1px solid #00000080",
    borderRadius: "16px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    height: "24px",
  },

  "& .MuiChip-label": {
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    color: "#00000080",
  },
});

export const SuperRecolheTooltip = styled(Tooltip)({
  "& .MuiTooltip-tooltip": {
    padding: "4px 8px",
    backgroundColor: "#202224",
    color: "#ffffff",
    fontSize: "14px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    lineHeight: "32px",
  },
});

export const ServicesListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 16px;
  background-color: #ffffff;
  border-radius: 4px;
  padding: 24px;
`;

export const ServicesRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ServicesTooltip = styled(Tooltip)`
  margin-left: 8px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.primary.main};
`;
